import { render } from "./HomeIndex.vue?vue&type=template&id=c81702da&scoped=true"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"

import "./HomeIndex.vue?vue&type=style&index=0&id=c81702da&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81702da"]])

export default __exports__